(ns iris.posts.route-data
  (:require
   [clojure.string :as string]
   [iris.posts.events :as posts-events]))


(defn ws-or
  [db route-params]
  (let [ws (:ws db)]
    (cond
      (and (:header route-params) (re-find #"^.+\.[A-Z]{3}$" (:header route-params)))
      (subs (:header route-params) (inc (string/last-index-of (:header route-params) ".")))

      (and (:tag route-params) (re-find #"^.+\.[A-Z]{3}$" (:tag route-params)))
      (subs (:tag route-params) (inc (string/last-index-of (:tag route-params) ".")))

      :else
      ws)))


(defn posts-query-params
  [db route]
  (let [route-data (:route route)
        route-params (:route-params route-data)
        query-params (:query-params route-data)]
    (update (merge {:ws (ws-or db route-params)
                    :limit (or (get-in db [:posts :limit]) 50)}
                   query-params)
            :limit
            int)))


(defn latest-query-params
  [db route]
  (let [query-params (posts-query-params db route)]
    (when (:ws query-params)
      query-params)))


(defn posts-route-query-params
  [db route]
  (let [route-data (:route route)
        route-params (:route-params route-data)
        query-params (posts-query-params db route)]
    (when (:ws query-params)
      (merge query-params route-params))))


(defn posts-header-query-params
  [db route]
  (let [route-data (:route route)
        header (get-in route-data [:route-params :header])
        query-params (posts-query-params db route)]
    (when (and header
               (:ws query-params)
               (re-find #"^.+\.[A-Z]{3}$" header))
      (merge query-params
             {:board (str "/" header)
              :level 1}))))

(defn thread-query-params
  [db route]
  (let [route-data (:route route)
        id (get-in route-data [:route-params :id])]
    (when id
      (merge (posts-query-params db route)
             {:board (str "+" id)
              :level 2}))))


(defn search-query-params
  [db route]
  (let [query-params (posts-query-params db route)
        q (or (:q query-params) "")]
    (when (:ws query-params)
      (merge {:index "admin"
              :order "desc"
              :page 1
              :maxcount 0}
             query-params
             {:q q
              :maxcount (int (:maxcount query-params))}))))


(defn latest-load-key
  [query-params]
  (select-keys query-params [:ws :staff :flag :tag :user :cc :ip :geo :cookie :bfp
                             :dfp :ua :mime :lang :thread :board :eid :id :level]))


(defn post-list-load-key
  [query-params]
  (select-keys query-params [:ws :level :bm :limit :status :sort :staff :flag
                             :tag :user :cc :ip :geo :cookie :bfp :dfp :ua
                             :mime :lang :thread :board :eid :id]))


(defn search-load-key
  [query-params]
  (select-keys query-params [:ws :index :limit :order :page :q :maxcount]))


(defn latest-effects
  [query-params]
  (cond-> [[::posts-events/set-posts-filters-from-qp query-params]
           [::posts-events/http-get-latest-post-list query-params]]
    (:ws query-params)
    (conj [::posts-events/personal-moderation-logs (:ws query-params)])))


(defn post-list-effects
  [query-params]
  (cond-> [[::posts-events/set-posts-filters-from-qp query-params]
           [::posts-events/http-get-post-list-batch-debounced query-params]]
    (:ws query-params)
    (conj [::posts-events/personal-moderation-logs (:ws query-params)])))


(defn posts-eid-effects
  [query-params]
  (cond-> (post-list-effects query-params)
    (:eid query-params)
    (into [[::posts-events/http-get-scope-eid-metadata (:eid query-params)]
           [::posts-events/http-get-log-timespan (:eid query-params)]
           [::posts-events/http-get-screening-status (:eid query-params)]])))


(defn posts-cc-effects
  [query-params]
  (cond-> (post-list-effects query-params)
    (:cc query-params)
    (into (let [cc-ruid (str ":" (:cc query-params))]
            [[::posts-events/http-get-log-timespan cc-ruid]
             [::posts-events/http-get-screening-status cc-ruid]]))))


(defn posts-ip-effects
  [query-params]
  (cond-> (post-list-effects query-params)
    (:ip query-params)
    (into (let [ip-ruid (str "^" (:ip query-params))]
            [[::posts-events/http-get-log-timespan ip-ruid]
             [::posts-events/http-get-screening-status ip-ruid]]))))


(defn posts-header-effects
  [query-params]
  (cond-> [[::posts-events/http-get-header-flow query-params (:board query-params)]]
    (:ws query-params)
    (conj [::posts-events/personal-moderation-logs (:ws query-params)])))


(defn search-effects
  [query-params]
  (cond-> []
    (not (empty? (:q query-params)))
    (into [[::posts-events/set-posts-filters-from-qp query-params]
           [::posts-events/http-post-search
            (:ws query-params)
            (:index query-params)
            (:limit query-params)
            (:order query-params)
           (:page query-params)
           (:q query-params)
            (:maxcount query-params)
            (posts-events/query-route-load query-params)]])

    (:ws query-params)
    (conj [::posts-events/personal-moderation-logs (:ws query-params)])))

(def primary-post-load-events
  #{::posts-events/http-get-thread
    ::posts-events/http-get-latest-post-list
    ::posts-events/http-get-post-list-batch-debounced
    ::posts-events/http-get-header-flow
    ::posts-events/http-post-search})

(defn primary-post-load-effect? [effect]
  (contains? primary-post-load-events (first effect)))

(defn non-primary-post-load-effects [effects]
  (remove primary-post-load-effect? effects))

(defn route-posts-load-start-effect
  [{:keys [panel previous-panel route-rev load-key same-load? effects]}]
  (when (and (some primary-post-load-effect? effects)
             (or (not same-load?)
                 (not= panel previous-panel)))
    [::posts-events/route-posts-load-started
     {:panel panel
      :route-rev route-rev
      :load-key load-key}]))

(defn with-route-posts-load-start [loader]
  (assoc loader
         :load-start-fn route-posts-load-start-effect
         :load-start-db-fn posts-events/start-route-posts-load
         :same-load-effects-fn non-primary-post-load-effects
         :tag-load-fn posts-events/with-route-load))


(def panel-loaders
  (update-vals
   {:thread-panel
    {:params-fn thread-query-params
     :load-key-fn posts-events/thread-load-key
     :effects-fn (fn [query-params]
                   [[::posts-events/http-get-thread query-params]])}

    :latest-panel
    {:params-fn latest-query-params
     :load-key-fn latest-load-key
     :effects-fn latest-effects}

    :posts-panel
    {:params-fn latest-query-params
     :load-key-fn post-list-load-key
     :effects-fn post-list-effects}

    :user-panel
    {:params-fn posts-route-query-params
     :load-key-fn post-list-load-key
     :effects-fn post-list-effects}

    :hashtag-panel
    {:params-fn posts-route-query-params
     :load-key-fn post-list-load-key
     :effects-fn post-list-effects}

    :posts-cc-panel
    {:params-fn posts-route-query-params
     :load-key-fn post-list-load-key
     :effects-fn posts-cc-effects}

    :posts-ip-panel
    {:params-fn posts-route-query-params
     :load-key-fn post-list-load-key
     :effects-fn posts-ip-effects}

    :posts-eid-panel
    {:params-fn posts-route-query-params
     :load-key-fn post-list-load-key
     :effects-fn posts-eid-effects}

    :posts-header-panel
    {:params-fn posts-header-query-params
     :load-key-fn post-list-load-key
     :effects-fn posts-header-effects}

    :search-panel
    {:params-fn search-query-params
     :load-key-fn search-load-key
     :effects-fn search-effects}}
   with-route-posts-load-start))
